import Guarantees from './Guarantees';

export default Guarantees;
